//Custom components
import StatCard from '../../../UI/Card/StatCard';
import { CurrencyFormatDisplay } from '../../../UI/NumberFormatDisplay/CurrencyFormatDisplay';

const TotalHousingPrice = ({ count }: { count: string | number }) => {
  return <StatCard title='Total Assistance Provided' stat={<CurrencyFormatDisplay value={count} prefix='$' />} />;
};

export default TotalHousingPrice;
